<template>
  <section>
    <fieldset v-for="field in datas" :key="field.name">
      <template v-if="['photo'].includes(field.type)">
        <label :for="field.name">{{field.label}}</label>
        <img :src="field.value.data" :alt="field.label">
        <input type="hidden" :name="field.name" :value="field.value.data">
      </template>

      <template v-if="['text', 'number', 'textarea'].includes(field.type)">
        <label :for="field.name">{{field.label}}</label>
        <span>
          {{field.value}}
          <small v-if="field.name == 'kilometers'">km</small>
        </span>
        <input type="hidden" :name="field.name" :value="field.value">
      </template>

      <template v-if="['checkbox'].includes(field.type)">
        <label>
          <input
            type="checkbox"
            :name="field.name"
            :disabled="field.name === 'counterInMiles'"
            :checked="field.value"
            @change="$store.dispatch('updateValue', {
              name: field.name,
              value: $event.target.checked
            })">
          {{field.label}}
        </label>
      </template>
      <small v-if="['checkbox'].includes(field.type) && field.name !== 'counterInMiles'" class="help app">
        <a href="https://www.allianz.fr/assurance-auto/mon-releve-kilometrique" target="_blank">Une question, un problème ? Cliquez ici</a>
      </small>
    </fieldset>

    <input type="hidden" name="npo" :value="$store.state.user.npo">
    <input type="hidden" name="mouvement" :value="$store.state.user.mouvement">
  </section>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    computed: mapState(['datas'])
  }
</script>

<style scoped lang="scss">
  @import '@/assets/_vars.scss';

  fieldset {
    appearance: none;
    margin: spacer();
    padding: 0;
    border: none;

    &:not(:first-child) {
      border-top: 1px solid rgba(black,.1);
      padding-top: spacer();
    }

    @include media('>tablet') {
      display: inline-block;
      width: calc(50% - #{$spacer*2});
      vertical-align: top;

      &:nth-child(2) {
        border-top: none;
        padding-top: 0;
      }

      &:last-of-type {
        width: calc(100% - #{$spacer*2});
      }
    }
  }

  label {
    display: flex;
  }

  input[type="checkbox"] {
    margin-right: .5em;
    // Vertical align
    align-self: baseline;
    position: relative;
    top: .1em;
  }

  img, span {
    display: block;
    margin-top: .5em;
  }

  small {
    font-size: 1em;
  }

  .help {
    &.app {
      text-align: left;
      width: 100%;
      display: block;
      margin-top: 5px;

      a {
        color: #00a9e0;
        font-size: 0.9em;
        text-decoration: none;
        margin-left: 8px;
      }
    }
  }
</style>
